export interface Column<T> {
  readonly key: string
  readonly header: string
  readonly render: (row: T) => React.ReactNode
  readonly numeric?: boolean
  readonly width?: number | string
}

export function DataTable<T>({
  columns,
  rows,
  getRowKey,
  empty,
  onRowClick,
}: {
  columns: readonly Column<T>[]
  rows: readonly T[]
  getRowKey: (row: T) => string
  empty?: React.ReactNode
  onRowClick?: (row: T) => void
}) {
  if (rows.length === 0 && empty !== undefined) return <>{empty}</>

  return (
    /* The scroll lives here, not on the page: a table wider than the viewport must not
       make the whole body scroll sideways. */
    <div className="data-table-scroll">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th
                key={column.key}
                scope="col"
                className={column.numeric === true ? 'numeric' : undefined}
                style={column.width !== undefined ? { width: column.width } : undefined}
              >
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr
              key={getRowKey(row)}
              onClick={onRowClick === undefined ? undefined : () => onRowClick(row)}
              style={onRowClick === undefined ? undefined : { cursor: 'pointer' }}
            >
              {columns.map((column) => (
                <td key={column.key} className={column.numeric === true ? 'numeric' : undefined}>
                  {column.render(row)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
